import { HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod } from '@api-new/authservice';
import { ENTRY_FLOW_STEPS } from '@app/sign-up/constants/entry-flow';
import { FlowStepModel } from '@app/sign-up/models/flow-step.model';
import { FlowStepsModel } from '@app/sign-up/models/flow-steps.model';
import { getFlowSteps } from '@app/sign-up/utils/get-flow-steps';
import { FlowModel } from '@shared/store/sign-up/flow/flow.model';

export const getFlowStep = (
  creationMethod: HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod | null,
  stepNumber: number,
): FlowStepModel<FlowModel> | undefined => {
  const selectedFlowSteps = stepNumber >= 0 ? getFlowSteps(creationMethod) : ENTRY_FLOW_STEPS;
  if (selectedFlowSteps == null) return undefined;

  return (selectedFlowSteps as FlowStepsModel<FlowModel>)[stepNumber];
};
